export default "__VITE_ASSET__CzOAWL_U__"